export default {
  opportunities: {
    selectedProducts: [],
    suggestedProducts: [],
    productAnalytics: [],
    boostProducts: [],
    filters: {
      products: [],
      units: [],
      referenceDate: ['', ''],
      currentDate: ['', ''],
    },
  },
  selectedAnalysisProducts: [],
  selectedBoostProducts: [],
}
